/**
 * @generated SignedSource<<bf286be25b06ed78f184c180cb2f8c2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BUDGET_TYPE = "FIXED_PRICE" | "NON_BILLABLE" | "TIME_AND_MATERIALS" | "RETAINER" | "FIXED_PRICE_V2" | "%future added value";
export type CANT_DELETE_TASK_REASON = "HAS_LOCKED_TIME" | "HAS_INVOICED_TIME" | "HAS_TIME_REGS" | "HAS_OTHER_PEOPLES_TIME_REGS" | "JIRA" | "GITHUB" | "UNIT4" | "NO_USER_TYPE" | "BLOCKED_BY_SUBTASK" | "NO_PERMISSION" | "%future added value";
export type DEPENDENCY_TYPE = "CANNOT_START" | "CANNOT_BE_COMPLETED" | "%future added value";
export type FILTER_SECTION = "PROJECT" | "SCOPING" | "SPRINT" | "SPRINT_BACKLOG" | "WORKFLOW" | "SCHEDULING_PEOPLE" | "SCHEDULING_PROJECTS" | "SCHEDULING_PLACEHOLDERS" | "SCHEDULING_CAPACITY_OVERVIEW" | "MY_TASKS" | "MY_LIST" | "MY_WORK" | "MY_TIMESHEETS" | "PROJECTS_OVERVIEW" | "INVOICING_OVERVIEW" | "INVOICING_INVOICES" | "FINANCIAL_PORTFOLIO_REPORT" | "TEAM_TIMESHEET" | "TIME_APPROVAL" | "REPORTED_TIME_TABLE" | "PROJECT_TIMELINE" | "UTILIZATION_REPORT" | "TASK_REPORT" | "SKILLS" | "LABELS" | "OPPORTUNITIES" | "%future added value";
export type LANGUAGE = "ENGLISH_US" | "ENGLISH_UK" | "ENGLISH_EU" | "SPANISH" | "DANISH" | "POLISH" | "FRENCH" | "%future added value";
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type STATUS_CATEGORY = "TODO" | "INPROGRESS" | "DONE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProjectSprintsPage_viewer$data = {
  readonly id: string;
  readonly language: LANGUAGE | null;
  readonly email: string | null;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly backendId: number | null;
  readonly harvestUser: boolean | null;
  readonly timerStartDate: string | null;
  readonly actualPersonId: string | null;
  readonly excludeFromCompanyLockedPeriod: boolean | null;
  readonly submitLockedDateYear: number | null;
  readonly submitLockedDateMonth: number | null;
  readonly submitLockedDateDay: number | null;
  readonly availableFeatureFlags: ReadonlyArray<{
    readonly key: string | null;
  } | null> | null;
  readonly timerTask: {
    readonly id: string;
  } | null;
  readonly projects: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly companyProjectId: number | null;
        readonly customProjectId: string | null;
        readonly name: string | null;
        readonly stage: {
          readonly id: string;
          readonly name: string | null;
          readonly profile: PROJECT_STATUS | null;
        } | null;
        readonly isInProjectGroup: boolean | null;
        readonly projectColor: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly filters: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly section: FILTER_SECTION | null;
        readonly value: string | null;
        readonly updatedAt: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly company: {
    readonly id: string;
    readonly backendId: number | null;
    readonly name: string | null;
    readonly currency: string | null;
    readonly harvestEnabled: boolean | null;
    readonly lockedPeriodYear: number | null;
    readonly lockedPeriodMonth: number | null;
    readonly lockedPeriodDay: number | null;
    readonly isUsingProjectAllocation: boolean | null;
    readonly isUsingMixedAllocation: boolean | null;
    readonly person: {
      readonly id: string;
      readonly role: {
        readonly id: string;
        readonly name: string | null;
      } | null;
    } | null;
    readonly modules: ReadonlyArray<{
      readonly moduleType: string | null;
    } | null> | null;
    readonly roles: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly labels: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly color: string | null;
          readonly category: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"LabelDropdownJS_labels">;
        } | null;
      } | null> | null;
    } | null;
    readonly clients: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string;
          readonly logoId: string | null;
          readonly logoDefaultId: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly teams: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly teamPersons: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly person: {
                  readonly id: string;
                } | null;
              } | null;
            } | null> | null;
          } | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"TeamDropdown_teams">;
      } | null> | null;
    } | null;
    readonly monday: number | null;
    readonly tuesday: number | null;
    readonly wednesday: number | null;
    readonly thursday: number | null;
    readonly friday: number | null;
    readonly saturday: number | null;
    readonly sunday: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"genericTaskContextMenu_company">;
  } | null;
  readonly projectGroup: {
    readonly id: string;
    readonly companyProjectGroupId: number | null;
    readonly name: string | null;
    readonly color: string | null;
    readonly projectGroupSprints: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly sprintPersons: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly availableMinutes?: number | null;
                readonly scheduledMinutes?: number | null;
                readonly taskAvailableMinutes?: number | null;
                readonly person: {
                  readonly id: string;
                  readonly firstName: string | null;
                  readonly lastName: string | null;
                  readonly profilePictureId: string | null;
                  readonly profilePictureDefaultId: number | null;
                  readonly role: {
                    readonly id: string;
                    readonly name: string | null;
                  } | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly projects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly demo: boolean | null;
          readonly stage: {
            readonly id: string;
            readonly name: string | null;
            readonly profile: PROJECT_STATUS | null;
          } | null;
          readonly companyProjectId: number | null;
          readonly customProjectId: string | null;
          readonly taskLevels: number | null;
          readonly sprintTimeBox: boolean | null;
          readonly sprintLengthInDays: number | null;
          readonly useManualAllocations: boolean | null;
          readonly remainingAutoCalculated: boolean | null;
          readonly projectColor: string | null;
          readonly estimationUnit: string | null;
          readonly projectStartYear: number | null;
          readonly projectStartMonth: number | null;
          readonly projectStartDay: number | null;
          readonly projectEndYear: number | null;
          readonly projectEndMonth: number | null;
          readonly projectEndDay: number | null;
          readonly minutesPerEstimationPoint: number | null;
          readonly manualProgressOnProjectEnabled: boolean | null;
          readonly manualProgressOnPhasesEnabled: boolean | null;
          readonly manualProgressOnTasksEnabled: boolean | null;
          readonly budgetWork: number | null;
          readonly budgetType: BUDGET_TYPE | null;
          readonly rateCard: {
            readonly id: string;
            readonly currency: string | null;
            readonly disabledRoles: ReadonlyArray<{
              readonly id: string;
            } | null> | null;
          } | null;
          readonly client: {
            readonly id: string;
            readonly name: string;
          } | null;
          readonly projectPersons: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly person: {
                  readonly id: string;
                  readonly active: boolean | null;
                  readonly permissions: ReadonlyArray<string | null> | null;
                  readonly firstName: string | null;
                  readonly lastName: string | null;
                  readonly fullName: string | null;
                  readonly initials: string | null;
                  readonly profilePictureId: string | null;
                  readonly profilePictureDefaultId: number | null;
                  readonly role: {
                    readonly id: string;
                    readonly name: string | null;
                  } | null;
                  readonly client: {
                    readonly id: string;
                  } | null;
                } | null;
                readonly role: {
                  readonly id: string;
                  readonly name: string | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly statusColumnsV2: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly order: number | null;
                readonly name: string | null;
                readonly projectGroupStatusColumnId: number | null;
                readonly jiraStatusId: string | null;
                readonly category: STATUS_CATEGORY | null;
              } | null;
            } | null> | null;
          } | null;
          readonly phases: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly name: string | null;
              } | null;
            } | null> | null;
          } | null;
          readonly sprints: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly projectGroupSprintId: string | null;
                readonly isProjectGroupSprint: boolean | null;
                readonly startDay: number | null;
                readonly startMonth: number | null;
                readonly startYear: number | null;
                readonly endDay: number | null;
                readonly endMonth: number | null;
                readonly endYear: number | null;
                readonly description?: string | null;
                readonly savedPerformance: number | null;
                readonly hasUnfinishedTask: boolean | null;
                readonly integrations: {
                  readonly id: string;
                  readonly jiraId: string | null;
                  readonly adoId: string | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly tasks: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly readOnly: {
                  readonly isReadOnly: boolean | null;
                } | null;
                readonly userCanDeleteTask: boolean | null;
                readonly userCantDeleteTaskReason: CANT_DELETE_TASK_REASON | null;
                readonly hasChildren: boolean | null;
                readonly sageIntacctId: string | null;
                readonly name: string | null;
                readonly description: string | null;
                readonly highPriority: boolean | null;
                readonly companyTaskId: number | null;
                readonly estimateForecast: number | null;
                readonly timeLeft?: number | null;
                readonly timeRegistrations?: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly id: string;
                      readonly minutesRegistered: number | null;
                      readonly billableMinutesRegistered: number | null;
                      readonly invoiced: boolean | null;
                      readonly person: {
                        readonly id: string;
                        readonly role: {
                          readonly id: string;
                        } | null;
                      } | null;
                    } | null;
                  } | null> | null;
                } | null;
                readonly progress?: number | null;
                readonly approved: boolean | null;
                readonly sortOrder: number | null;
                readonly blocked: boolean | null;
                readonly bug: boolean | null;
                readonly deadlineYear: number | null;
                readonly deadlineMonth: number | null;
                readonly deadlineDay: number | null;
                readonly startYear: number | null;
                readonly startMonth: number | null;
                readonly startDay: number | null;
                readonly startFrom: string | null;
                readonly deadlineFrom: string | null;
                readonly hasDependency: boolean | null;
                readonly canStart: boolean | null;
                readonly canBeSetToDone: boolean | null;
                readonly subTaskCount: number | null;
                readonly latestUiUpdateAt: string | null;
                readonly hasLockedTime: boolean | null;
                readonly hasInvoicedTime: boolean | null;
                readonly favoured: boolean | null;
                readonly billable: boolean | null;
                readonly parentTaskId: string | null;
                readonly project: {
                  readonly id: string;
                  readonly demo: boolean | null;
                  readonly estimationUnit: string | null;
                  readonly minutesPerEstimationPoint: number | null;
                  readonly companyProjectId: number | null;
                  readonly customProjectId: string | null;
                  readonly projectEndYear: number | null;
                  readonly projectEndMonth: number | null;
                  readonly projectEndDay: number | null;
                  readonly projectColor: string | null;
                  readonly remainingAutoCalculated: boolean | null;
                  readonly name: string | null;
                  readonly stage: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly profile: PROJECT_STATUS | null;
                  } | null;
                  readonly projectGroupId: string | null;
                  readonly harvestProject: {
                    readonly id: string;
                  } | null;
                  readonly client: {
                    readonly id: string;
                  } | null;
                  readonly rateCard: {
                    readonly id: string;
                    readonly currency: string | null;
                    readonly disabledRoles: ReadonlyArray<{
                      readonly id: string;
                    } | null> | null;
                  } | null;
                  readonly useTaskHierarchy: boolean | null;
                  readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
                } | null;
                readonly taskLabels: ReadonlyArray<{
                  readonly id: string;
                  readonly label: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly color: string | null;
                  } | null;
                } | null> | null;
                readonly sprint: {
                  readonly id: string;
                  readonly endYear: number | null;
                  readonly endMonth: number | null;
                  readonly endDay: number | null;
                  readonly savedPerformance: number | null;
                  readonly name: string | null;
                  readonly projectGroupSprintId: string | null;
                  readonly isProjectGroupSprint: boolean | null;
                } | null;
                readonly statusColumnV2: {
                  readonly id: string;
                  readonly name: string | null;
                  readonly category: STATUS_CATEGORY | null;
                  readonly projectGroupStatusColumnId: number | null;
                } | null;
                readonly phase: {
                  readonly id: string;
                  readonly name: string | null;
                  readonly deadlineYear: number | null;
                  readonly deadlineMonth: number | null;
                  readonly deadlineDay: number | null;
                } | null;
                readonly role: {
                  readonly id: string;
                  readonly name: string | null;
                } | null;
                readonly assignedPersons: ReadonlyArray<{
                  readonly id: string;
                  readonly active: boolean | null;
                  readonly firstName: string | null;
                  readonly lastName: string | null;
                  readonly profilePictureId: string | null;
                  readonly profilePictureDefaultId: number | null;
                  readonly permissions: ReadonlyArray<string | null> | null;
                  readonly client: {
                    readonly id: string;
                  } | null;
                } | null> | null;
                readonly taskDismissedNotifications: {
                  readonly taskOverrunPredictionDismissed: boolean | null;
                } | null;
                readonly thisTaskDependsOn: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly id: string;
                      readonly type: DEPENDENCY_TYPE | null;
                      readonly thisDependsOnTask: {
                        readonly id: string;
                        readonly name: string | null;
                        readonly deadlineYear: number | null;
                        readonly deadlineMonth: number | null;
                        readonly deadlineDay: number | null;
                        readonly startYear: number | null;
                        readonly startMonth: number | null;
                        readonly startDay: number | null;
                      } | null;
                    } | null;
                  } | null> | null;
                } | null;
                readonly owner: {
                  readonly id: string;
                  readonly permissions: ReadonlyArray<string | null> | null;
                } | null;
                readonly followers: ReadonlyArray<{
                  readonly id: string;
                  readonly permissions: ReadonlyArray<string | null> | null;
                } | null> | null;
                readonly parentTask: {
                  readonly id: string;
                  readonly name: string | null;
                } | null;
                readonly progressDetails: {
                  readonly progress: number | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
        } | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_projectGroup" | "SecondaryNavigation_projectGroup">;
  } | null;
  readonly projectGroups: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly companyProjectGroupId: number | null;
        readonly name: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly project: {
    readonly id: string;
    readonly demo: boolean | null;
    readonly name: string | null;
    readonly isInProjectGroup: boolean | null;
    readonly projectGroupId: string | null;
    readonly stage: {
      readonly id: string;
      readonly name: string | null;
      readonly profile: PROJECT_STATUS | null;
    } | null;
    readonly companyProjectId: number | null;
    readonly customProjectId: string | null;
    readonly taskLevels: number | null;
    readonly sprintTimeBox: boolean | null;
    readonly sprintLengthInDays: number | null;
    readonly projectColor: string | null;
    readonly estimationUnit: string | null;
    readonly remainingAutoCalculated: boolean | null;
    readonly minutesPerEstimationPoint: number | null;
    readonly useManualAllocations: boolean | null;
    readonly useTaskFollowers: boolean | null;
    readonly useTaskOwner: boolean | null;
    readonly isJiraProject: boolean | null;
    readonly harvestProjectId: string | null;
    readonly projectStartYear: number | null;
    readonly projectStartMonth: number | null;
    readonly projectStartDay: number | null;
    readonly projectEndYear: number | null;
    readonly projectEndMonth: number | null;
    readonly projectEndDay: number | null;
    readonly manualProgressOnProjectEnabled: boolean | null;
    readonly manualProgressOnPhasesEnabled: boolean | null;
    readonly manualProgressOnTasksEnabled: boolean | null;
    readonly budgetWork: number | null;
    readonly budgetType: BUDGET_TYPE | null;
    readonly rateCard: {
      readonly id: string;
      readonly currency: string | null;
      readonly disabledRoles: ReadonlyArray<{
        readonly id: string;
      } | null> | null;
    } | null;
    readonly projectPersons: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly person: {
            readonly id: string;
            readonly active: boolean | null;
            readonly permissions: ReadonlyArray<string | null> | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly fullName: string | null;
            readonly initials: string | null;
            readonly profilePictureId: string | null;
            readonly profilePictureDefaultId: number | null;
            readonly role: {
              readonly id: string;
              readonly name: string | null;
            } | null;
            readonly client: {
              readonly id: string;
            } | null;
          } | null;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly statusColumnsV2: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly order: number | null;
          readonly name: string | null;
          readonly jiraStatusId: string | null;
          readonly category: STATUS_CATEGORY | null;
        } | null;
      } | null> | null;
    } | null;
    readonly phases: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly sprints: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly timeLeft: number | null;
          readonly forecast: number | null;
          readonly startDay: number | null;
          readonly startMonth: number | null;
          readonly startYear: number | null;
          readonly endDay: number | null;
          readonly endMonth: number | null;
          readonly endYear: number | null;
          readonly description?: string | null;
          readonly savedPerformance: number | null;
          readonly hasUnfinishedTask: boolean | null;
          readonly sprintPersons: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly availableMinutes?: number | null;
                readonly scheduledMinutes?: number | null;
                readonly taskAvailableMinutes?: number | null;
                readonly person: {
                  readonly id: string;
                  readonly firstName: string | null;
                  readonly lastName: string | null;
                  readonly profilePictureId: string | null;
                  readonly profilePictureDefaultId: number | null;
                  readonly role: {
                    readonly id: string;
                    readonly name: string | null;
                  } | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly integrations: {
            readonly id: string;
            readonly jiraId: string | null;
            readonly adoId: string | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly tasks: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly readOnly: {
            readonly isReadOnly: boolean | null;
          } | null;
          readonly userCanDeleteTask: boolean | null;
          readonly userCantDeleteTaskReason: CANT_DELETE_TASK_REASON | null;
          readonly name: string | null;
          readonly description: string | null;
          readonly highPriority: boolean | null;
          readonly companyTaskId: number | null;
          readonly estimateForecast: number | null;
          readonly timeLeft?: number | null;
          readonly timeRegistrations?: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly minutesRegistered: number | null;
                readonly billableMinutesRegistered: number | null;
                readonly invoiced: boolean | null;
                readonly person: {
                  readonly id: string;
                  readonly role: {
                    readonly id: string;
                  } | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly progress?: number | null;
          readonly approved: boolean | null;
          readonly sortOrder: number | null;
          readonly blocked: boolean | null;
          readonly bug: boolean | null;
          readonly deadlineYear: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineDay: number | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly startFrom: string | null;
          readonly deadlineFrom: string | null;
          readonly hasDependency: boolean | null;
          readonly canStart: boolean | null;
          readonly canBeSetToDone: boolean | null;
          readonly subTaskCount: number | null;
          readonly latestUiUpdateAt: string | null;
          readonly hasLockedTime: boolean | null;
          readonly hasInvoicedTime: boolean | null;
          readonly favoured: boolean | null;
          readonly billable: boolean | null;
          readonly hasChildren: boolean | null;
          readonly parentTaskId: string | null;
          readonly sageIntacctId: string | null;
          readonly taskLabels: ReadonlyArray<{
            readonly id: string;
            readonly label: {
              readonly id: string;
              readonly name: string | null;
              readonly color: string | null;
            } | null;
          } | null> | null;
          readonly sprint: {
            readonly id: string;
            readonly endYear: number | null;
            readonly endMonth: number | null;
            readonly endDay: number | null;
            readonly name: string | null;
          } | null;
          readonly statusColumnV2: {
            readonly id: string;
            readonly name: string | null;
            readonly category: STATUS_CATEGORY | null;
          } | null;
          readonly phase: {
            readonly id: string;
            readonly name: string | null;
            readonly deadlineYear: number | null;
            readonly deadlineMonth: number | null;
            readonly deadlineDay: number | null;
          } | null;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly assignedPersons: ReadonlyArray<{
            readonly id: string;
            readonly active: boolean | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly email: string | null;
            readonly profilePictureId: string | null;
            readonly profilePictureDefaultId: number | null;
            readonly permissions: ReadonlyArray<string | null> | null;
            readonly client: {
              readonly id: string;
            } | null;
          } | null> | null;
          readonly taskDismissedNotifications: {
            readonly taskOverrunPredictionDismissed: boolean | null;
          } | null;
          readonly project: {
            readonly id: string;
            readonly name: string | null;
            readonly demo: boolean | null;
            readonly client: {
              readonly id: string;
              readonly name: string;
            } | null;
            readonly harvestProject: {
              readonly id: string;
            } | null;
            readonly remainingAutoCalculated: boolean | null;
            readonly companyProjectId: number | null;
            readonly customProjectId: string | null;
            readonly estimationUnit: string | null;
            readonly minutesPerEstimationPoint: number | null;
            readonly projectStartYear: number | null;
            readonly projectStartMonth: number | null;
            readonly projectStartDay: number | null;
            readonly projectEndYear: number | null;
            readonly projectEndMonth: number | null;
            readonly projectEndDay: number | null;
            readonly projectColor: string | null;
            readonly stage: {
              readonly id: string;
              readonly name: string | null;
              readonly profile: PROJECT_STATUS | null;
            } | null;
            readonly useTaskHierarchy: boolean | null;
          } | null;
          readonly thisTaskDependsOn: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly id: string;
                readonly type: DEPENDENCY_TYPE | null;
                readonly thisDependsOnTask: {
                  readonly id: string;
                  readonly name: string | null;
                  readonly deadlineYear: number | null;
                  readonly deadlineMonth: number | null;
                  readonly deadlineDay: number | null;
                  readonly startYear: number | null;
                  readonly startMonth: number | null;
                  readonly startDay: number | null;
                } | null;
              } | null;
            } | null> | null;
          } | null;
          readonly owner: {
            readonly id: string;
            readonly permissions: ReadonlyArray<string | null> | null;
          } | null;
          readonly followers: ReadonlyArray<{
            readonly id: string;
            readonly permissions: ReadonlyArray<string | null> | null;
          } | null> | null;
          readonly parentTask: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly progressDetails: {
            readonly progress: number | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_project" | "SecondaryNavigation_project">;
  } | null;
  readonly psProject: {
    readonly " $fragmentSpreads": FragmentRefs<"ProjectHeader_psProject">;
  } | null;
  readonly " $fragmentType": "ProjectSprintsPage_viewer";
};
export type ProjectSprintsPage_viewer$key = {
  readonly " $data"?: ProjectSprintsPage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectSprintsPage_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "count": null,
  "cursor": null,
  "direction": "forward",
  "path": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backendId",
  "storageKey": null
},
v6 = [
  (v1/*: any*/)
],
v7 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000000
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "stage",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profile",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInProjectGroup",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v19 = [
  (v1/*: any*/),
  (v11/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectGroupId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": (v8/*: any*/),
  "concreteType": "SprintPersonTypeConnection",
  "kind": "LinkedField",
  "name": "sprintPersons",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SprintPersonTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SprintPerson",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "condition": "fetchLazyData",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "availableMinutes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "scheduledMinutes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "taskAvailableMinutes",
                  "storageKey": null
                }
              ]
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "person",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                (v23/*: any*/),
                (v24/*: any*/),
                (v20/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "sprintPersons(first:1000000)"
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "demo",
  "storageKey": null
},
v27 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "DeprecatedProjectIndicatorJS_project"
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskLevels",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sprintTimeBox",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sprintLengthInDays",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useManualAllocations",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingAutoCalculated",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minutesPerEstimationPoint",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnProjectEnabled",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnPhasesEnabled",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnTasksEnabled",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetWork",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "budgetType",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "RateCard",
  "kind": "LinkedField",
  "name": "rateCard",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "kind": "LinkedField",
      "name": "disabledRoles",
      "plural": true,
      "selections": (v6/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissions",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v51 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectPersonTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectPerson",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "initials",
                "storageKey": null
              },
              (v23/*: any*/),
              (v24/*: any*/),
              (v20/*: any*/),
              (v50/*: any*/)
            ],
            "storageKey": null
          },
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupStatusColumnId",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraStatusId",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v56 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PhaseTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PhaseType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v19/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupSprintId",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProjectGroupSprint",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDay",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endMonth",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endYear",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v66 = {
  "condition": "fetchLazyData",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v65/*: any*/)
  ]
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "savedPerformance",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUnfinishedTask",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "SprintIntegrationsType",
  "kind": "LinkedField",
  "name": "integrations",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adoId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskReadOnly",
  "kind": "LinkedField",
  "name": "readOnly",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isReadOnly",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCanDeleteTask",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userCantDeleteTaskReason",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasChildren",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctId",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "highPriority",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecast",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeft",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v80 = {
  "condition": "fetchLazyData",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v78/*: any*/),
    {
      "alias": "timeRegistrations",
      "args": null,
      "concreteType": "TimeRegTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_timeRegistrations_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeRegTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeRegType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minutesRegistered",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "billableMinutesRegistered",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "invoiced",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "person",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Role",
                      "kind": "LinkedField",
                      "name": "role",
                      "plural": false,
                      "selections": (v6/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v15/*: any*/)
              ],
              "storageKey": null
            },
            (v16/*: any*/)
          ],
          "storageKey": null
        },
        (v17/*: any*/)
      ],
      "storageKey": null
    },
    (v79/*: any*/)
  ]
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approved",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blocked",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bug",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startFrom",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineFrom",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasDependency",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canStart",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canBeSetToDone",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subTaskCount",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestUiUpdateAt",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasLockedTime",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasInvoicedTime",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentTaskId",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupId",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useTaskHierarchy",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskLabel",
  "kind": "LinkedField",
  "name": "taskLabels",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Label",
      "kind": "LinkedField",
      "name": "label",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v11/*: any*/),
        (v21/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "concreteType": "PhaseType",
  "kind": "LinkedField",
  "name": "phase",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v11/*: any*/),
    (v85/*: any*/),
    (v86/*: any*/),
    (v87/*: any*/)
  ],
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskDismissedNotifications",
  "kind": "LinkedField",
  "name": "taskDismissedNotifications",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskOverrunPredictionDismissed",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v106 = {
  "alias": "thisTaskDependsOn",
  "args": null,
  "concreteType": "DependencyTypeConnection",
  "kind": "LinkedField",
  "name": "__Task_thisTaskDependsOn_connection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DependencyTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DependencyType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Task",
              "kind": "LinkedField",
              "name": "thisDependsOnTask",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v11/*: any*/),
                (v85/*: any*/),
                (v86/*: any*/),
                (v87/*: any*/),
                (v61/*: any*/),
                (v60/*: any*/),
                (v59/*: any*/)
              ],
              "storageKey": null
            },
            (v15/*: any*/)
          ],
          "storageKey": null
        },
        (v16/*: any*/)
      ],
      "storageKey": null
    },
    (v17/*: any*/)
  ],
  "storageKey": null
},
v107 = [
  (v1/*: any*/),
  (v49/*: any*/)
],
v108 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v107/*: any*/),
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "followers",
  "plural": true,
  "selections": (v107/*: any*/),
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "parentTask",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskProgress",
  "kind": "LinkedField",
  "name": "progressDetails",
  "plural": false,
  "selections": [
    (v79/*: any*/)
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchLazyData"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "groupId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "onlyActiveSprint"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "personId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sprintIds"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "filters"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "projectGroup",
          "projectGroupSprints"
        ]
      },
      (v0/*: any*/),
      (v0/*: any*/),
      (v0/*: any*/),
      (v0/*: any*/),
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "projectGroups"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "project",
          "sprints"
        ]
      },
      (v0/*: any*/),
      (v0/*: any*/),
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "project",
          "tasks"
        ]
      }
    ]
  },
  "name": "ProjectSprintsPage_viewer",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "harvestUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timerStartDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "excludeFromCompanyLockedPeriod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submitLockedDateYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submitLockedDateMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submitLockedDateDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeatureFlag",
      "kind": "LinkedField",
      "name": "availableFeatureFlags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "timerTask",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v8/*: any*/),
      "concreteType": "ProjectTypeConnection",
      "kind": "LinkedField",
      "name": "projects",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/),
                (v11/*: any*/),
                (v12/*: any*/),
                (v13/*: any*/),
                (v14/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "projects(first:1000000)"
    },
    {
      "alias": "filters",
      "args": null,
      "concreteType": "FilterTypeConnection",
      "kind": "LinkedField",
      "name": "__Viewer_filters_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FilterTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Filter",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v11/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "section",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "updatedAt",
                  "storageKey": null
                },
                (v15/*: any*/)
              ],
              "storageKey": null
            },
            (v16/*: any*/)
          ],
          "storageKey": null
        },
        (v17/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "genericTaskContextMenu_company"
        },
        (v1/*: any*/),
        (v5/*: any*/),
        (v11/*: any*/),
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "harvestEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUsingProjectAllocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUsingMixedAllocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "id",
              "variableName": "personId"
            }
          ],
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "person",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v20/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Module",
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "moduleType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v8/*: any*/),
          "concreteType": "RoleTypeConnection",
          "kind": "LinkedField",
          "name": "roles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v19/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "roles(first:1000000)"
        },
        {
          "alias": null,
          "args": [
            (v7/*: any*/),
            {
              "kind": "Literal",
              "name": "labelType",
              "value": "TASK"
            }
          ],
          "concreteType": "LabelTypeConnection",
          "kind": "LinkedField",
          "name": "labels",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LabelTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Label",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v11/*: any*/),
                    (v21/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LabelCategory",
                      "kind": "LinkedField",
                      "name": "category",
                      "plural": false,
                      "selections": (v19/*: any*/),
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "LabelDropdownJS_labels"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "labels(first:1000000,labelType:\"TASK\")"
        },
        {
          "alias": null,
          "args": (v8/*: any*/),
          "concreteType": "ClientTypeConnection",
          "kind": "LinkedField",
          "name": "clients",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ClientTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Client",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v11/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "logoId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "logoDefaultId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "clients(first:1000000)"
        },
        {
          "alias": null,
          "args": (v8/*: any*/),
          "concreteType": "TeamTypeConnection",
          "kind": "LinkedField",
          "name": "teams",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TeamDropdown_teams"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Team",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v11/*: any*/),
                    {
                      "alias": null,
                      "args": (v8/*: any*/),
                      "concreteType": "TeamPersonTypeConnection",
                      "kind": "LinkedField",
                      "name": "teamPersons",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "TeamPersonTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "TeamPerson",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Person",
                                  "kind": "LinkedField",
                                  "name": "person",
                                  "plural": false,
                                  "selections": (v6/*: any*/),
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "teamPersons(first:1000000)"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "teams(first:1000000)"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "monday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tuesday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "wednesday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thursday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "friday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "saturday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sunday",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "groupId"
        }
      ],
      "concreteType": "ProjectGroupType",
      "kind": "LinkedField",
      "name": "projectGroup",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectHeader_projectGroup"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SecondaryNavigation_projectGroup"
        },
        (v1/*: any*/),
        (v22/*: any*/),
        (v11/*: any*/),
        (v21/*: any*/),
        {
          "alias": "projectGroupSprints",
          "args": null,
          "concreteType": "ProjectGroupSprintTypeConnection",
          "kind": "LinkedField",
          "name": "__ProjectGroup_projectGroupSprints_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectGroupSprintTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectGroupSprintType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v11/*: any*/),
                    (v25/*: any*/),
                    (v15/*: any*/)
                  ],
                  "storageKey": null
                },
                (v16/*: any*/)
              ],
              "storageKey": null
            },
            (v17/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v8/*: any*/),
          "concreteType": "ProjectTypeConnection",
          "kind": "LinkedField",
          "name": "projects",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v11/*: any*/),
                    (v26/*: any*/),
                    (v12/*: any*/),
                    (v9/*: any*/),
                    (v10/*: any*/),
                    (v27/*: any*/),
                    (v28/*: any*/),
                    (v29/*: any*/),
                    (v30/*: any*/),
                    (v31/*: any*/),
                    (v32/*: any*/),
                    (v14/*: any*/),
                    (v33/*: any*/),
                    (v34/*: any*/),
                    (v35/*: any*/),
                    (v36/*: any*/),
                    (v37/*: any*/),
                    (v38/*: any*/),
                    (v39/*: any*/),
                    (v40/*: any*/),
                    (v41/*: any*/),
                    (v42/*: any*/),
                    (v43/*: any*/),
                    (v44/*: any*/),
                    (v45/*: any*/),
                    (v46/*: any*/),
                    (v47/*: any*/),
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "first",
                          "value": 10000
                        }
                      ],
                      "concreteType": "ProjectPersonTypeConnection",
                      "kind": "LinkedField",
                      "name": "projectPersons",
                      "plural": false,
                      "selections": (v51/*: any*/),
                      "storageKey": "projectPersons(first:10000)"
                    },
                    {
                      "alias": null,
                      "args": (v8/*: any*/),
                      "concreteType": "StatusColumnV2TypeConnection",
                      "kind": "LinkedField",
                      "name": "statusColumnsV2",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "StatusColumnV2TypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "StatusColumnV2",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                (v52/*: any*/),
                                (v11/*: any*/),
                                (v53/*: any*/),
                                (v54/*: any*/),
                                (v55/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": "statusColumnsV2(first:1000000)"
                    },
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "first",
                          "value": 1000
                        }
                      ],
                      "concreteType": "PhaseTypeConnection",
                      "kind": "LinkedField",
                      "name": "phases",
                      "plural": false,
                      "selections": (v56/*: any*/),
                      "storageKey": "phases(first:1000)"
                    },
                    {
                      "alias": "sprints",
                      "args": null,
                      "concreteType": "SprintTypeConnection",
                      "kind": "LinkedField",
                      "name": "__Project_sprints_connection",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SprintTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Sprint",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                (v11/*: any*/),
                                (v57/*: any*/),
                                (v58/*: any*/),
                                (v59/*: any*/),
                                (v60/*: any*/),
                                (v61/*: any*/),
                                (v62/*: any*/),
                                (v63/*: any*/),
                                (v64/*: any*/),
                                (v66/*: any*/),
                                (v67/*: any*/),
                                (v68/*: any*/),
                                (v69/*: any*/),
                                (v15/*: any*/)
                              ],
                              "storageKey": null
                            },
                            (v16/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v17/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": "tasks",
                      "args": null,
                      "concreteType": "TaskTypeConnection",
                      "kind": "LinkedField",
                      "name": "__Project_tasks_connection",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "TaskTypeEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Task",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v1/*: any*/),
                                (v70/*: any*/),
                                (v71/*: any*/),
                                (v72/*: any*/),
                                (v73/*: any*/),
                                (v74/*: any*/),
                                (v11/*: any*/),
                                (v65/*: any*/),
                                (v75/*: any*/),
                                (v76/*: any*/),
                                (v77/*: any*/),
                                (v80/*: any*/),
                                (v81/*: any*/),
                                (v82/*: any*/),
                                (v83/*: any*/),
                                (v84/*: any*/),
                                (v85/*: any*/),
                                (v86/*: any*/),
                                (v87/*: any*/),
                                (v61/*: any*/),
                                (v60/*: any*/),
                                (v59/*: any*/),
                                (v88/*: any*/),
                                (v89/*: any*/),
                                (v90/*: any*/),
                                (v91/*: any*/),
                                (v92/*: any*/),
                                (v93/*: any*/),
                                (v94/*: any*/),
                                (v95/*: any*/),
                                (v96/*: any*/),
                                (v97/*: any*/),
                                (v98/*: any*/),
                                (v99/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ProjectType",
                                  "kind": "LinkedField",
                                  "name": "project",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v26/*: any*/),
                                    (v33/*: any*/),
                                    (v40/*: any*/),
                                    (v9/*: any*/),
                                    (v10/*: any*/),
                                    (v27/*: any*/),
                                    (v37/*: any*/),
                                    (v38/*: any*/),
                                    (v39/*: any*/),
                                    (v14/*: any*/),
                                    (v32/*: any*/),
                                    (v11/*: any*/),
                                    (v12/*: any*/),
                                    (v100/*: any*/),
                                    (v101/*: any*/),
                                    (v50/*: any*/),
                                    (v46/*: any*/),
                                    (v102/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v103/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Sprint",
                                  "kind": "LinkedField",
                                  "name": "sprint",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v64/*: any*/),
                                    (v63/*: any*/),
                                    (v62/*: any*/),
                                    (v67/*: any*/),
                                    (v11/*: any*/),
                                    (v57/*: any*/),
                                    (v58/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "StatusColumnV2",
                                  "kind": "LinkedField",
                                  "name": "statusColumnV2",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v11/*: any*/),
                                    (v55/*: any*/),
                                    (v53/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v104/*: any*/),
                                (v20/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Person",
                                  "kind": "LinkedField",
                                  "name": "assignedPersons",
                                  "plural": true,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v48/*: any*/),
                                    (v3/*: any*/),
                                    (v4/*: any*/),
                                    (v23/*: any*/),
                                    (v24/*: any*/),
                                    (v49/*: any*/),
                                    (v50/*: any*/)
                                  ],
                                  "storageKey": null
                                },
                                (v105/*: any*/),
                                (v106/*: any*/),
                                (v108/*: any*/),
                                (v109/*: any*/),
                                (v110/*: any*/),
                                (v111/*: any*/),
                                (v15/*: any*/)
                              ],
                              "storageKey": null
                            },
                            (v16/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v17/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "projects(first:1000000)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "projectGroups",
      "args": null,
      "concreteType": "ProjectGroupTypeConnection",
      "kind": "LinkedField",
      "name": "__Viewer_projectGroups_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectGroupTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectGroupType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v22/*: any*/),
                (v11/*: any*/),
                (v15/*: any*/)
              ],
              "storageKey": null
            },
            (v16/*: any*/)
          ],
          "storageKey": null
        },
        (v17/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectHeader_project"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SecondaryNavigation_project"
        },
        (v1/*: any*/),
        (v26/*: any*/),
        (v11/*: any*/),
        (v13/*: any*/),
        (v100/*: any*/),
        (v12/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v28/*: any*/),
        (v29/*: any*/),
        (v30/*: any*/),
        (v14/*: any*/),
        (v33/*: any*/),
        (v32/*: any*/),
        (v40/*: any*/),
        (v31/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTaskFollowers",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTaskOwner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isJiraProject",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "harvestProjectId",
          "storageKey": null
        },
        (v34/*: any*/),
        (v35/*: any*/),
        (v36/*: any*/),
        (v37/*: any*/),
        (v38/*: any*/),
        (v39/*: any*/),
        (v41/*: any*/),
        (v42/*: any*/),
        (v43/*: any*/),
        (v44/*: any*/),
        (v45/*: any*/),
        (v46/*: any*/),
        {
          "alias": null,
          "args": (v8/*: any*/),
          "concreteType": "ProjectPersonTypeConnection",
          "kind": "LinkedField",
          "name": "projectPersons",
          "plural": false,
          "selections": (v51/*: any*/),
          "storageKey": "projectPersons(first:1000000)"
        },
        {
          "alias": null,
          "args": (v8/*: any*/),
          "concreteType": "StatusColumnV2TypeConnection",
          "kind": "LinkedField",
          "name": "statusColumnsV2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StatusColumnV2TypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StatusColumnV2",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v52/*: any*/),
                    (v11/*: any*/),
                    (v54/*: any*/),
                    (v55/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "statusColumnsV2(first:1000000)"
        },
        {
          "alias": null,
          "args": (v8/*: any*/),
          "concreteType": "PhaseTypeConnection",
          "kind": "LinkedField",
          "name": "phases",
          "plural": false,
          "selections": (v56/*: any*/),
          "storageKey": "phases(first:1000000)"
        },
        {
          "alias": "sprints",
          "args": null,
          "concreteType": "SprintTypeConnection",
          "kind": "LinkedField",
          "name": "__Project_sprints_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SprintTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Sprint",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v11/*: any*/),
                    (v78/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "forecast",
                      "storageKey": null
                    },
                    (v59/*: any*/),
                    (v60/*: any*/),
                    (v61/*: any*/),
                    (v62/*: any*/),
                    (v63/*: any*/),
                    (v64/*: any*/),
                    (v66/*: any*/),
                    (v67/*: any*/),
                    (v68/*: any*/),
                    (v25/*: any*/),
                    (v69/*: any*/),
                    (v15/*: any*/)
                  ],
                  "storageKey": null
                },
                (v16/*: any*/)
              ],
              "storageKey": null
            },
            (v17/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": "tasks",
          "args": null,
          "concreteType": "TaskTypeConnection",
          "kind": "LinkedField",
          "name": "__Project_tasks_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TaskTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Task",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    (v70/*: any*/),
                    (v71/*: any*/),
                    (v72/*: any*/),
                    (v11/*: any*/),
                    (v65/*: any*/),
                    (v75/*: any*/),
                    (v76/*: any*/),
                    (v77/*: any*/),
                    (v80/*: any*/),
                    (v81/*: any*/),
                    (v82/*: any*/),
                    (v83/*: any*/),
                    (v84/*: any*/),
                    (v85/*: any*/),
                    (v86/*: any*/),
                    (v87/*: any*/),
                    (v61/*: any*/),
                    (v60/*: any*/),
                    (v59/*: any*/),
                    (v88/*: any*/),
                    (v89/*: any*/),
                    (v90/*: any*/),
                    (v91/*: any*/),
                    (v92/*: any*/),
                    (v93/*: any*/),
                    (v94/*: any*/),
                    (v95/*: any*/),
                    (v96/*: any*/),
                    (v97/*: any*/),
                    (v98/*: any*/),
                    (v73/*: any*/),
                    (v99/*: any*/),
                    (v74/*: any*/),
                    (v103/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Sprint",
                      "kind": "LinkedField",
                      "name": "sprint",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v64/*: any*/),
                        (v63/*: any*/),
                        (v62/*: any*/),
                        (v11/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StatusColumnV2",
                      "kind": "LinkedField",
                      "name": "statusColumnV2",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v11/*: any*/),
                        (v55/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v104/*: any*/),
                    (v20/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "assignedPersons",
                      "plural": true,
                      "selections": [
                        (v1/*: any*/),
                        (v48/*: any*/),
                        (v3/*: any*/),
                        (v4/*: any*/),
                        (v2/*: any*/),
                        (v23/*: any*/),
                        (v24/*: any*/),
                        (v49/*: any*/),
                        (v50/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v105/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectType",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v11/*: any*/),
                        (v26/*: any*/),
                        (v47/*: any*/),
                        (v101/*: any*/),
                        (v32/*: any*/),
                        (v9/*: any*/),
                        (v10/*: any*/),
                        (v33/*: any*/),
                        (v40/*: any*/),
                        (v34/*: any*/),
                        (v35/*: any*/),
                        (v36/*: any*/),
                        (v37/*: any*/),
                        (v38/*: any*/),
                        (v39/*: any*/),
                        (v14/*: any*/),
                        (v12/*: any*/),
                        (v102/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v106/*: any*/),
                    (v108/*: any*/),
                    (v109/*: any*/),
                    (v110/*: any*/),
                    (v111/*: any*/),
                    (v15/*: any*/)
                  ],
                  "storageKey": null
                },
                (v16/*: any*/)
              ],
              "storageKey": null
            },
            (v17/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "companyProjectId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectServiceProjectType",
      "kind": "LinkedField",
      "name": "psProject",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectHeader_psProject"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "79400458d25ca61df7c36e1b2cfc6556";

export default node;
